const initialState = {
  saleReturns:     [],
  purchaseReturns: [],
  selectedReturn:  null,
  loading:         false,
  actionLoading:   false,
  error:           null,
  total:           0,
};

const ReturnReducer = (state = initialState, action) => {
  switch (action.type) {

    // ── Fetch Sale Returns ───────────────────────────────────
    case 'FETCH_SALE_RETURNS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_SALE_RETURNS_SUCCESS':
      return { ...state, loading: false, saleReturns: action.payload.returns || [], total: action.payload.total || 0 };
    case 'FETCH_SALE_RETURNS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // ── Get Sale Return by ID ────────────────────────────────
    case 'GET_SALE_RETURN_REQUEST':
      return { ...state, actionLoading: true };
    case 'GET_SALE_RETURN_SUCCESS':
      return { ...state, actionLoading: false, selectedReturn: action.payload };
    case 'GET_SALE_RETURN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // ── Create Sale Return ───────────────────────────────────
    case 'CREATE_SALE_RETURN_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_SALE_RETURN_SUCCESS':
      return { ...state, actionLoading: false };
    case 'CREATE_SALE_RETURN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // ── Delete Sale Return ───────────────────────────────────
    case 'DELETE_SALE_RETURN_REQUEST':
      return { ...state, actionLoading: true };
    case 'DELETE_SALE_RETURN_SUCCESS':
      return { ...state, actionLoading: false, saleReturns: state.saleReturns.filter(r => r.id !== action.payload) };
    case 'DELETE_SALE_RETURN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // ── Fetch Purchase Returns ───────────────────────────────
    case 'FETCH_PURCHASE_RETURNS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_PURCHASE_RETURNS_SUCCESS':
      return { ...state, loading: false, purchaseReturns: action.payload.returns || [], total: action.payload.total || 0 };
    case 'FETCH_PURCHASE_RETURNS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // ── Get Purchase Return by ID ────────────────────────────
    case 'GET_PURCHASE_RETURN_REQUEST':
      return { ...state, actionLoading: true };
    case 'GET_PURCHASE_RETURN_SUCCESS':
      return { ...state, actionLoading: false, selectedReturn: action.payload };
    case 'GET_PURCHASE_RETURN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // ── Create Purchase Return ───────────────────────────────
    case 'CREATE_PURCHASE_RETURN_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_PURCHASE_RETURN_SUCCESS':
      return { ...state, actionLoading: false };
    case 'CREATE_PURCHASE_RETURN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // ── Delete Purchase Return ───────────────────────────────
    case 'DELETE_PURCHASE_RETURN_REQUEST':
      return { ...state, actionLoading: true };
    case 'DELETE_PURCHASE_RETURN_SUCCESS':
      return { ...state, actionLoading: false, purchaseReturns: state.purchaseReturns.filter(r => r.id !== action.payload) };
    case 'DELETE_PURCHASE_RETURN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default ReturnReducer;